module.exports = __webpack_public_path__ + "static/media/right-bg-aa.0e088d9c.png";